/* ==========================================================================
   Beanwatch · Artikel- und Rezeptseiten
   Zwei Helfer, die auf beiden Seitentypen gebraucht werden:
   ein mitlaufendes Inhaltsverzeichnis und verwandte Beiträge. Dazu der
   Hallenplan mit Snake für den Festival-Artikel.
   ========================================================================== */

window.BWBeitrag = (function () {
  'use strict';

  const ruhig = window.BW && window.BW.wenigerBewegung;

  /* ------------------------------------------------------------------
     Das Verzeichnis auf schmalen Fenstern
     Ohne Seitenspalte stand es bisher unter dem ganzen Artikel — dort
     sucht es niemand mehr. Es wandert deshalb nach oben, direkt hinter
     die Kurzübersicht, und steht dort eingeklappt: für die Suche voll
     lesbar, ohne den Anfang des Artikels zuzustellen.
     Das Verzeichnis kommt als Element, nicht über eine feste ID: Im
     Shopify-Theme heisst <main> schon «inhalt». Die Beschriftung des
     Klappknopfs liest es aus data-text-klapp (übersetzt im Theme).
     ------------------------------------------------------------------ */
  function verzeichnisUmhaengen(nav) {
    if (!nav) return;

    const seite = nav.closest('.beitragsseite');
    const text = document.querySelector('.beitragstext');
    if (!seite || !text) return;

    // Merkt sich den Platz in der Seitenspalte für den Weg zurück.
    const platz = document.createComment('inhalt');
    seite.insertBefore(platz, nav);

    const huelle = document.createElement('details');
    huelle.className = 'inhalt-klapp';
    const knopf = document.createElement('summary');
    knopf.textContent = nav.dataset.textKlapp || 'Inhaltsverzeichnis';
    huelle.appendChild(knopf);

    const schmal = window.matchMedia('(max-width:1080px)');

    function stellen() {
      if (schmal.matches) {
        if (huelle.contains(nav)) return;
        huelle.appendChild(nav);
        const kurz = text.querySelector('.kurzuebersicht');
        if (kurz) kurz.after(huelle); else text.prepend(huelle);
      } else {
        if (!huelle.contains(nav)) return;
        platz.after(nav);
        huelle.remove();
      }
    }

    stellen();
    // Beim Drehen des Geräts und bei jeder Grössenänderung. Beides, weil
    // change nicht überall zuverlässig kommt und stellen() nichts tut,
    // solange das Verzeichnis schon richtig steht.
    schmal.addEventListener('change', stellen);
    window.addEventListener('resize', stellen);
  }

  /* ------------------------------------------------------------------
     Inhaltsverzeichnis
     Markiert beim Scrollen den Abschnitt, in dem man gerade steht.
     ------------------------------------------------------------------ */
  function inhaltsverzeichnis(zielAuswahl, ueberschriften) {
    const nav = document.querySelector(zielAuswahl);
    if (!nav) return;

    verzeichnisUmhaengen(nav);

    // querySelectorAll statt gsap.utils.toArray: Das Verzeichnis braucht
    // GSAP nicht und soll auch ohne laufen.
    const titel = [...document.querySelectorAll(ueberschriften)].filter(h => h.id);
    if (!titel.length) return;

    const links = titel.map(h => nav.querySelector(`a[href="#${h.id}"]`)).filter(Boolean);

    // Das sanfte Springen macht ankersprung() in basis.js, seitenweit und
    // mitsamt Adresszeile und Tastaturfokus.

    if (ruhig) return;

    titel.forEach((h) => {
      const link = nav.querySelector(`a[href="#${h.id}"]`);
      if (!link) return;

      ScrollTrigger.create({
        trigger: h,
        start: 'top 130',
        end: () => {
          const naechster = titel[titel.indexOf(h) + 1];
          return naechster ? naechster.getBoundingClientRect().top + window.scrollY - 130 : 'max';
        },
        onToggle: (self) => {
          if (!self.isActive) return;
          links.forEach(l => l.classList.remove('ist-aktiv'));
          link.classList.add('ist-aktiv');
        }
      });
    });

    // Absätze treten beim Lesen ruhig herein. Bilder, Tabellen und die
    // Kurzübersicht gehören dazu, sonst stehen sie ohne Übergang da.
    const bausteine = [
      'h2', 'h3', 'h4', 'p', 'ul', 'ol',
      '.merksatz', '.kurzuebersicht', '.artikelbild', '.tabellenrahmen', '.autorbox'
    ].map((teil) => `.beitragstext > ${teil}`).join(', ');

    gsap.utils.toArray(bausteine)
      .forEach((el) => {
        gsap.from(el, {
          opacity: 0, y: 22, duration: 0.8,
          scrollTrigger: { trigger: el, start: 'top 92%', once: true }
        });
      });
  }

  /* ------------------------------------------------------------------
     Verwandte Beiträge aus dem Wissensbestand
     ------------------------------------------------------------------ */
  /**
   * @param {string} zielAuswahl Container für die Karten
   * @param {Array}  themen      Themen, zu denen passende Beiträge gesucht werden
   * @param {number} anzahl      Wie viele Karten
   * @param {string} ausser      Titel des aktuellen Beitrags, wird ausgelassen.
   *                             Über den Titel und nicht über das Ziel, weil
   *                             Wissensartikel und Brew Guides noch auf eine
   *                             gemeinsame Mustervorlage zeigen.
   * @param {string} [art]       Optional auf eine Art einschränken, etwa
   *                             'rezept'. Ohne Angabe zählen alle Arten. Die
   *                             Rezeptseiten brauchen das, weil sie unter
   *                             "Noch mehr Rezepte" sonst Wissensartikel zeigen.
   * @param {Object} [vorrang]   Optional, was vorne steht, ohne das Übrige
   *                             auszuschliessen (Kaffeeseiten, seit 13.10.2026):
   *                             { ziele: [...], art: 'rezept' }. Zuerst die
   *                             Beiträge in ziele (die Rezepte, die genau
   *                             diesen Kaffee empfehlen, auch ohne gemeinsames
   *                             Thema), dann die der Art, dann der Rest. So
   *                             füllen Artikel oder Werkzeuge nur auf, wenn es
   *                             zu wenige Rezepte gibt.
   */
  function verwandte(zielAuswahl, themen, anzahl, ausser, art, vorrang) {
    const raster = document.querySelector(zielAuswahl);
    if (!raster || !window.BWWissen) return;

    const naehe = b => (b.themen || []).filter(t => themen.includes(t)).length;
    const ziele = (vorrang && vorrang.ziele) || [];
    const zuerst = b => (ziele.includes(b.ziel) ? 2 : 0) +
      (vorrang && vorrang.art && b.art === vorrang.art ? 1 : 0);

    const treffer = BWWissen.BEITRAEGE
      .filter(b => b.stand === 'live')
      // Zum Start Ausgeblendetes (start.js) nicht vorschlagen. In der
      // Entwurfsansicht erscheint es wie vor dem Start-Modus.
      .filter(b => !window.BWStart || BWStart.zeigen(b.ziel))
      // Aktuelles (Blog aktuelles) ist an ein Datum gebunden und steht nie
      // unter «Passt dazu». Im Theme zeichnet bw-verwandte es ebenso nicht.
      .filter(b => b.art !== 'aktuell')
      .filter(b => !art || b.art === art)
      .filter(b => naehe(b) > 0 || ziele.includes(b.ziel))
      .filter(b => !ausser || b.titel !== ausser)
      // Je mehr Themen sich decken, desto weiter vorn. Sonst schlüge der
      // Cold Brew immer Espresso-Rezepte vor, statt den Cold Brew Tonic.
      // Mit vorrang gilt das innerhalb der Stufen von zuerst().
      // Bei Gleichstand bleibt die Reihenfolge des Bestands, also neuste zuerst.
      .sort((a, b) => (zuerst(b) - zuerst(a)) || (naehe(b) - naehe(a)))
      .slice(0, anzahl || 3);

    raster.innerHTML = treffer.map(BWWissen.karte).join('');

    if (ruhig) return;
    gsap.from(raster.children, {
      opacity: 0, y: 34, duration: 0.9, stagger: 0.09,
      scrollTrigger: { trigger: raster, start: 'top 88%', once: true }
    });
  }

  /* ------------------------------------------------------------------
     Verweis auf die Anleitung
     Der Artikel erklärt Herkunft und Unterschiede, die Zubereitung steht
     auf einer eigenen Seite. Der Kasten dazwischen zeigt das Getränk im
     Schnitt und füllt sich beim Hereinscrollen von unten.

     Die Schichten kommen aus BWHub.GETRAENKE, damit Hub und Artikel
     dasselbe Glas zeichnen und niemand zwei Datensätze pflegen muss.
     ------------------------------------------------------------------ */
  function verweiskasten(auswahl) {
    const kaesten = [...document.querySelectorAll(auswahl || '.verweiskasten[data-getraenk]')];
    if (!kaesten.length || !window.BWHub || !window.bwGlas) return;

    kaesten.forEach((kasten, i) => {
      const name = kasten.dataset.getraenk;
      const g = BWHub.GETRAENKE.find(x => x.name === name);
      const buehne = kasten.querySelector('.verweis-glas');
      if (!g || !buehne) return;

      buehne.innerHTML = bwGlas({
        gefaess: g.gefaess,
        schichten: g.schichten,
        eis: g.eis,
        id: 'vk' + i,
        alt: g.name + ' im Schnitt'
      });

      if (ruhig) return;

      const schichten = buehne.querySelectorAll('.schicht');
      const eis = buehne.querySelectorAll('.eis rect');
      gsap.set(schichten, { scaleY: 0 });
      gsap.set(eis, { scale: 0, transformOrigin: '50% 50%' });

      gsap.timeline({ scrollTrigger: { trigger: kasten, start: 'top 84%', once: true } })
        // immediateRender:false, damit der Text sichtbar bleibt, falls der
        // Trigger nie feuert. Sonst stünde der Kasten leer da.
        .from(kasten.querySelectorAll('.verweis-text > *'), {
          opacity: 0, y: 18, duration: 0.6, stagger: 0.08, immediateRender: false
        })
        .to(schichten, { scaleY: 1, duration: 0.72, stagger: 0.14, ease: 'power2.out' }, 0.1)
        .to(eis, { scale: 1, duration: 0.45, stagger: 0.08, ease: 'back.out(2.4)' }, '-=0.35');

      // Beim Hover füllt es sich nach, wie auf dem Hub.
      kasten.addEventListener('mouseenter', () => {
        gsap.fromTo(schichten,
          { scaleY: 0.9 },
          { scaleY: 1, duration: 0.5, stagger: 0.05, ease: 'back.out(2)', overwrite: true });
      });
    });
  }

  /* ------------------------------------------------------------------
     Die neuesten Beiträge
     Für die Autorenseite: die jüngsten Artikel und Rezepte aus dem
     Bestand, unabhängig vom Thema. Das Datum steht im Bestand als Text
     («5. Juni 2026»), BWWissen.datumWert macht daraus eine Zahl. Im Theme
     zeichnet Liquid diese Karten selbst, dort ruft niemand neueste() auf.
     ------------------------------------------------------------------ */

  /**
   * @param {string} zielAuswahl Container für die Karten
   * @param {number} anzahl      Wie viele Karten
   * @param {Array}  [arten]     Welche Arten zählen, sonst Artikel, Rezepte
   *                             und Aktuelles (bis zum Ablaufdatum)
   */
  function neueste(zielAuswahl, anzahl, arten) {
    const raster = document.querySelector(zielAuswahl);
    if (!raster || !window.BWWissen) return;
    const zaehlt = arten || ['wissen', 'rezept', 'aktuell'];
    const datumWert = BWWissen.datumWert;

    const treffer = BWWissen.BEITRAEGE
      .filter(b => b.stand === 'live')
      .filter(b => !window.BWStart || BWStart.zeigen(b.ziel))
      .filter(b => zaehlt.includes(b.art))
      // Abgelaufenes Aktuelles (wissen.js) nicht mehr zeigen.
      .filter(b => !BWWissen.abgelaufen || !BWWissen.abgelaufen(b))
      .filter(b => datumWert(b.datum) > 0)
      .sort((a, b) => datumWert(b.datum) - datumWert(a.datum))
      .slice(0, anzahl || 3);

    raster.innerHTML = treffer.map(BWWissen.karte).join('');

    if (ruhig) return;
    gsap.from(raster.children, {
      opacity: 0, y: 34, duration: 0.9, stagger: 0.09,
      scrollTrigger: { trigger: raster, start: 'top 88%', once: true }
    });
  }

  /* ------------------------------------------------------------------
     Hallenplan mit Snake
     Der Festival-Artikel zeigt den Weg vom Haupteingang zu Stand 26 als
     SVG in einem <picture> (werkzeug/hallenplan-festival.py). Trägt die
     Figure data-hallenplan, setzt diese Funktion die passende Fassung
     inline ein und lässt den Weg wie die Snake aus dem Spiel vom Eingang
     zum Stand kriechen (Wunsch Joscha, 11.10.2026): Unterwegs frisst sie
     fünf Kaffeetassen und wird mit jeder länger. Am Ende steht der ganze
     Weg, der Ring um den Stand pulsiert, und das Bild kommt zurück.
     Weil der Endzustand genau das stehende Bild ist, sieht man den Tausch
     nicht, und das <picture> wechselt danach wieder zwischen breit und
     schmal.

     Die SVG bringt dafür die IDs weg, weg-start, weg-pfeil, stand-ring,
     weg-kopf und becher mit. Ohne GSAP, bei reduzierter Bewegung oder wenn
     die Datei nicht lädt, bleibt einfach das Bild stehen. Im alten Theme
     läuft dieses Skript nicht, dort steht der Plan ebenfalls still.
     ------------------------------------------------------------------ */
  const SNAKE = {
    tempo: 40,        // Planeinheiten pro Sekunde, der Weg misst rund 225
    koerper: 16,      // Länge der Snake am Eingang
    wachstum: 9,      // so viel länger wird sie mit jeder Tasse
    start: 'top 65%'  // nach dem Einblenden der Absätze (top 92%)
  };
  const SCHMAL = '(max-width:700px)';

  function hallenplan(auswahl) {
    const figuren = gsap.utils.toArray(auswahl || '.beitragstext figure[data-hallenplan]');
    if (ruhig || !figuren.length || !window.ScrollTrigger) return;
    figuren.forEach(snakeFigur);
  }

  function snakeFigur(figur) {
    const bild = figur.querySelector('img');
    const rahmen = figur.querySelector('picture') || bild;
    if (!bild) return;

    // Dieselbe Wahl wie das <picture>: bis 700 px die schmale Fassung.
    const schmal = window.matchMedia(SCHMAL);
    const quelle = figur.querySelector('source[media]');
    const adresse = schmal.matches && quelle ? quelle.getAttribute('srcset') : bild.getAttribute('src');
    if (!adresse) return;

    // Zuerst über die eigene Domain (/cdn/shop/files/…), damit kein CORS
    // dazwischenkommt, sonst über das Shopify-CDN selbst.
    const eigen = adresse.replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/(\d+\/)+files\//, '/cdn/shop/files/');
    const holen = (url) => fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(r.status)));

    // Das Bild muss beim Zurücktauschen fertig sein, auch wenn es lazy war.
    bild.loading = 'eager';

    holen(eigen)
      .catch(() => holen(adresse))
      .then((text) => {
        const svg = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
        if (!svg || svg.nodeName !== 'svg' || !svg.querySelector('#weg')) return;
        snakeLaufen(figur, rahmen, bild, document.importNode(svg, true), schmal);
      })
      .catch(() => {});
  }

  function snakeLaufen(figur, rahmen, bild, svg, schmal) {
    // Die Teile merken und die IDs entfernen, damit nichts mit der Seite
    // kollidiert (die Datei bringt etwa id="titel" mit).
    const teil = {};
    svg.querySelectorAll('[id]').forEach((el) => {
      teil[el.id] = el;
      el.removeAttribute('id');
    });
    const { weg, 'weg-kopf': kopf, becher, 'weg-pfeil': pfeil, 'stand-ring': ring } = teil;
    if (!weg || !kopf || !becher || !pfeil || !ring) return;

    svg.removeAttribute('aria-labelledby');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', bild.alt || '');

    // Aussehen wie das Bild: Breite, Rahmen, Rundung.
    const stil = getComputedStyle(bild);
    const box = svg.viewBox.baseVal;
    Object.assign(svg.style, {
      display: 'block', width: '100%', height: 'auto',
      aspectRatio: `${box.width} / ${box.height}`,
      boxSizing: stil.boxSizing,
      borderRadius: stil.borderRadius,
      borderWidth: stil.borderTopWidth, borderStyle: stil.borderTopStyle, borderColor: stil.borderTopColor,
      backgroundColor: stil.backgroundColor
    });

    rahmen.after(svg);
    rahmen.style.display = 'none';

    const L = weg.getTotalLength();

    // Wo jede Tasse auf dem Weg steht: den Pfad abtasten, nächster Punkt.
    const tassen = Array.from(becher.querySelectorAll('.tasse')).map((el) => {
      const x = Number(el.dataset.x), y = Number(el.dataset.y);
      let stelle = 0, naechste = Infinity;
      for (let s = 0; s <= L; s += 0.5) {
        const p = weg.getPointAtLength(s);
        const d = (p.x - x) ** 2 + (p.y - y) ** 2;
        if (d < naechste) { naechste = d; stelle = s; }
      }
      return { el, x, y, stelle, gefressen: false };
    });

    // Startzustand: Weg unsichtbar, Tassen und Kopf am Eingang, Pfeil und
    // Ring aus.
    const z = { s: 0, koerper: SNAKE.koerper, happs: 1 };
    becher.setAttribute('visibility', 'visible');
    kopf.setAttribute('visibility', 'visible');
    gsap.set([pfeil, ring], { opacity: 0 });

    function richtung(s) {
      const a = weg.getPointAtLength(Math.max(0, s - 0.6));
      const b = weg.getPointAtLength(Math.min(L, s + 0.6));
      return Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
    }

    function zeichnen() {
      const b = Math.min(z.koerper, z.s);
      // Sichtbar ist nur das Stück [s − b, s]; die Lücke ist länger als der
      // ganze Weg, damit kein zweiter Strich auftaucht.
      weg.setAttribute('stroke-dasharray', `${b} ${L + b + 10}`);
      weg.setAttribute('stroke-dashoffset', -(z.s - b));
      const p = weg.getPointAtLength(z.s);
      kopf.setAttribute('transform',
        `translate(${p.x} ${p.y}) rotate(${richtung(z.s)}) scale(${z.happs})`);

      tassen.forEach((t) => {
        if (t.gefressen || z.s < t.stelle - 3) return;
        t.gefressen = true;
        gsap.to(t.el, { scale: 0, opacity: 0, svgOrigin: `${t.x} ${t.y}`, duration: 0.25, ease: 'back.in(2)' });
        gsap.to(z, { koerper: `+=${SNAKE.wachstum}`, duration: 0.35, ease: 'power1.out' });
        gsap.fromTo(z, { happs: 1.3 }, { happs: 1, duration: 0.3, ease: 'back.out(3)' });
      });
    }
    zeichnen();

    const ringMitte = `${ring.getAttribute('cx')} ${ring.getAttribute('cy')}`;
    const tl = gsap.timeline({ paused: true, onComplete: zurueck })
      .to(z, { s: L, duration: L / SNAKE.tempo, ease: 'none', onUpdate: zeichnen })
      // Am Stand: der Schwanz läuft bis zum Eingang nach, der ganze Weg steht.
      .to(z, { koerper: L, duration: 0.7, ease: 'power2.out', onUpdate: zeichnen })
      .to(kopf, { opacity: 0, duration: 0.3 }, '<')
      .to(pfeil, { opacity: 1, duration: 0.3 }, '<0.2')
      .to(ring, { opacity: 1, duration: 0.2 }, '<')
      .to(ring, { scale: 1.35, svgOrigin: ringMitte, duration: 0.28, ease: 'power1.out', repeat: 3, yoyo: true });

    const st = ScrollTrigger.create({ trigger: svg, start: SNAKE.start, once: true, onEnter: () => tl.play() });
    // Steht der Plan schon weiter oben im Bild, läuft die Snake gleich los.
    if (st.progress > 0) tl.play();

    // Springt die Breite über 700 px, passt die Fassung nicht mehr: abbrechen.
    function wechsel() { tl.kill(); st.kill(); zurueck(); }
    schmal.addEventListener('change', wechsel, { once: true });

    // Das Bild zurück. Erst wenn es dekodiert ist, sonst blitzt es leer auf.
    function zurueck() {
      schmal.removeEventListener('change', wechsel);
      const fertig = bild.decode ? bild.decode().catch(() => {}) : Promise.resolve();
      fertig.then(() => {
        rahmen.style.display = '';
        svg.remove();
      });
    }
  }

  return { inhaltsverzeichnis, verwandte, verweiskasten, neueste, hallenplan };
})();
